import { mapGetters } from 'vuex';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import schoolsBreadcrumb from '../schoolsbreadcrumb/schools-breadcrumb.vue';

export default {
    name: 'schoolsWelcome',
    props: {
        data: Object,
        alt: {
            default: 'Welcome-Schools Movoto'
        }
    },
    components: {
        mvtMapStatic,
        schoolsBreadcrumb
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        info(){
            return this.data.cityInfo || this.data.neighInfo;
        },
        hasBannerImg(){
            return this.data.bannerUrl && ['vschools_district','vschools_neighbourhood','vschools_districtstate','vschools_zipcode'].indexOf(this.data.pageType) !== -1;
        }
    }
};